import { z } from 'zod';

/**
 * Where an asset is in the upload lifecycle (N12).
 *
 * `pending` — a presigned PUT was minted and the row reserved, but the server
 * has not yet seen the bytes. Nothing may read a pending asset: its size, type
 * and dimensions are still only what the client *claimed*.
 *
 * `ready` — the server head-checked the object, decoded it, and vouches for it.
 * The only state a read URL is minted for.
 *
 * `deleted` — the row is a tombstone awaiting the purge worker; the object may
 * still exist for a few minutes. It is a distinct state from the soft-delete
 * timestamp because the worker needs to find exactly these rows.
 */
export const MEDIA_STATUSES = ['pending', 'ready', 'deleted'] as const;

export const MediaStatusSchema = z.enum(MEDIA_STATUSES);

export type MediaStatus = (typeof MEDIA_STATUSES)[number];
